(function () {
  var STORAGE_KEY = 'uic_wishlist';
  // The id list alone cannot be turned back into products — Liquid has no
  // "product by id" lookup — so keep a parallel id -> handle map and use the
  // handle to re-fetch the card on the wishlist page.
  var HANDLE_KEY = 'uic_wishlist_handles';
  var RESUME_PARAM = 'wishlist_add';
  var RESUME_HANDLE_PARAM = 'wishlist_handle';

  function isLoggedIn() {
    return document.body.getAttribute('data-customer-logged-in') === 'true';
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  /* Every write goes through here, so this is the one place that can
     tell the rest of the page the list changed -- adds, removes, the
     cart's "save to wishlist", and the resume after login all land
     here. Anything that renders FROM the list (the wishlist page)
     listens for this instead of only reading it once on load. */
  function notifyChanged(source) {
    try {
      document.dispatchEvent(
        new CustomEvent('uic:wishlist:change', { detail: { source: source || 'local' } })
      );
    } catch (e) {}
  }

  function saveWishlist(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch (e) {}
    notifyChanged();
  }

  function getHandles() {
    try {
      var map = JSON.parse(localStorage.getItem(HANDLE_KEY) || '{}');
      return map && typeof map === 'object' ? map : {};
    } catch (e) {
      return {};
    }
  }

  function rememberHandle(id, handle) {
    if (!handle) return;
    var map = getHandles();
    if (map[String(id)] === handle) return;
    map[String(id)] = handle;
    try {
      localStorage.setItem(HANDLE_KEY, JSON.stringify(map));
    } catch (e) {}
  }

  function isWishlisted(id) {
    return getWishlist().indexOf(String(id)) !== -1;
  }

  function add(id) {
    var list = getWishlist();
    id = String(id);
    if (list.indexOf(id) === -1) {
      list.push(id);
      saveWishlist(list);
    }
  }

  function toggle(id) {
    var list = getWishlist();
    id = String(id);
    var idx = list.indexOf(id);
    if (idx === -1) {
      list.push(id);
    } else {
      list.splice(idx, 1);
    }
    saveWishlist(list);
    return idx === -1;
  }

  /* ---- Tooltip confirmation (pointer devices) ----

     On a desktop the cursor is still sitting on the heart after the
     click, so the tooltip is on screen when the state changes. It used
     to flip straight to the NEXT action -- press Add, and the label
     immediately reads "Remove from Wishlist", which looks like the
     item was removed rather than added.

     So the tooltip reports what just happened, holds for a moment,
     then settles to the next action. The mobile toast covers the same
     need where there is no cursor. */

  var confirmBtn = null;
  var confirmTimer = null;

  function confirmOnButton(btn, message) {
    if (!btn) return;
    if (window.matchMedia && !window.matchMedia('(hover: hover)').matches) return;

    var tip = btn.querySelector('.wishlist-btn__tooltip');
    if (!tip) return;

    confirmBtn = btn;
    tip.textContent = message;

    clearTimeout(confirmTimer);
    confirmTimer = setTimeout(function () {
      confirmBtn = null;
      updateAll();
    }, 1400);
  }

  /* ---- Add / remove animation ----

     Styles and the reasoning behind two different motions are in
     global.css. Strip the classes afterwards so a repeat tap restarts
     the animation instead of the browser keeping the finished one. */
  function animateButton(btn, added) {
    if (!btn) return;

    btn.classList.remove('is-pop', 'is-unpop');
    // Forces a reflow so the removal above is committed as its own
    // styling pass -- without it the browser coalesces both changes
    // and the animation never re-runs.
    void btn.offsetWidth;
    btn.classList.add(added ? 'is-pop' : 'is-unpop');

    clearTimeout(btn._uicWishTimer);
    btn._uicWishTimer = setTimeout(function () {
      btn.classList.remove('is-pop', 'is-unpop');
    }, 600);
  }

  var updating = false;
  function updateAll() {
    if (updating) return;
    updating = true;
    document.querySelectorAll('.wishlist-btn[data-wishlist-id]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-id');
      var added = isWishlisted(id);
      if (btn.classList.contains('is-wishlisted') !== added) {
        btn.classList.toggle('is-wishlisted', added);
      }
      var tip = btn.querySelector('.wishlist-btn__tooltip');
      var label = added ? 'Remove from Wishlist' : 'Add to Wishlist';

      /* Leave the tooltip alone while it is showing a confirmation.
         updateAll also runs from a MutationObserver every 300ms, so
         without this the confirmation would be overwritten almost
         immediately. */
      if (tip && btn !== confirmBtn && tip.textContent !== label) {
        tip.textContent = label;
      }

      /* aria-label always carries the action, never the confirmation:
         it is what a screen reader announces as the control's name,
         and "Added to wishlist" would be a wrong name for a button
         whose next press removes. */
      if (btn.getAttribute('aria-label') !== label) btn.setAttribute('aria-label', label);
    });
    updateCount();
    updating = false;
  }

  /* Header badge. Runs from updateAll, so it follows every add, every
     remove, and the MutationObserver that catches cards swapped in by
     filtering or pagination.

     [data-wishlist-badge], NOT [data-wishlist-count]: the wishlist
     page owns that second attribute for its own "2 items saved" line.
     Sharing it meant this wrote a bare number over that sentence, and
     the page's own querySelector picked up the header badge instead
     of its paragraph. */
  function updateCount() {
    var count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-badge]').forEach(function (el) {
      var text = count > 99 ? '99+' : String(count);
      if (count === 0) {
        el.hidden = true;
        el.textContent = '';
        el.removeAttribute('aria-label');
      } else {
        el.hidden = false;
        if (el.textContent !== text) el.textContent = text;
        el.setAttribute('aria-label', count === 1 ? '1 item in wishlist' : count + ' items in wishlist');
      }
    });
  }

  /* ---- Confirmation toast ----

     Phone and tablet only. On a desktop the heart fills under the
     pointer and the tooltip flips to "Remove from Wishlist", so the
     state change is already visible. On touch there is no hover, the
     finger is covering the icon at the moment it changes, and the
     tooltip only flashes -- so nothing confirms the tap landed.

     One reused node with aria-live, so repeated taps replace the
     message instead of stacking toasts up the screen. */

  var toastEl = null;
  var toastTimer = null;

  /* Filled heart for saved, outline for removed -- see the note on
     .uic-wishlist-toast in global.css. aria-hidden because the toast's
     own text already says which happened; without it a screen reader
     announces the graphic as well. */
  var HEART_PATH =
    'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z';

  function heartSvg(filled) {
    return (
      '<svg viewBox="0 0 24 24" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="' +
      HEART_PATH +
      '" fill="' +
      (filled ? 'currentColor' : 'none') +
      '" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>'
    );
  }

  function toast(message, added) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 989px)').matches) return;

    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'uic-wishlist-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(toastEl);
    }

    /* Build the icon separately from the text so the message itself
       stays a plain text node -- the whole element is the aria-live
       region, and markup injected around the words is what makes a
       screen reader re-read the lot. */
    toastEl.innerHTML = heartSvg(!!added) + '<span></span>';
    toastEl.lastChild.textContent = message;

    /* Restart the animation on a repeat tap: without dropping the
       class and forcing a reflow the browser keeps the running one
       and the toast never re-appears. */
    toastEl.classList.remove('is-visible');
    void toastEl.offsetWidth;
    toastEl.classList.add('is-visible');

    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 1800);
  }

  /* ---- Login prompt ---- */

  var modal = null;
  var lastFocused = null;

  function returnUrlWith(id, handle) {
    var url = new URL(window.location.href);
    url.searchParams.set(RESUME_PARAM, id);
    if (handle) url.searchParams.set(RESUME_HANDLE_PARAM, handle);
    return url.pathname + url.search + url.hash;
  }

  function openModal(id, handle) {
    modal = modal || document.querySelector('[data-wishlist-modal]');
    if (!modal) return false;

    // Carry the product through the login round trip so it saves on return.
    var back = encodeURIComponent(returnUrlWith(id, handle));
    ['[data-wishlist-login]', '[data-wishlist-register]'].forEach(function (sel) {
      var link = modal.querySelector(sel);
      if (!link) return;
      var base = (link.getAttribute('href') || '').split('?')[0];
      link.setAttribute('href', base + '?return_url=' + back);
    });

    lastFocused = document.activeElement;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    var first = modal.querySelector('[data-wishlist-login]');
    if (first) first.focus();
    return true;
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.style.overflow = '';
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wishlist-modal-close]')) {
      closeModal();
      return;
    }

    var btn = e.target.closest('.wishlist-btn[data-wishlist-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var id = btn.getAttribute('data-wishlist-id');
    var handle = btn.getAttribute('data-wishlist-handle');
    rememberHandle(id, handle);

    // Removing something already saved never needs an account.
    if (!isLoggedIn() && !isWishlisted(id)) {
      if (openModal(id, handle)) return;
    }

    var added = toggle(id);
    updateAll();
    animateButton(btn, added);

    /* Two different strings on purpose. The tooltip is a small pill
       that opens leftward from the heart, so on a narrow card a long
       label runs off the edge -- it gets the one-word version. The
       toast has the full width of the screen, so it gets the sentence
       that actually tells the customer where the item went. */
    confirmOnButton(btn, added ? 'Saved' : 'Removed');
    toast(added ? 'Saved to your wishlist' : 'Removed from your wishlist', added);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* ---- Resume after login/registration ---- */

  function resumePending() {
    var params = new URLSearchParams(window.location.search);
    var id = params.get(RESUME_PARAM);
    if (!id) return;

    if (isLoggedIn()) {
      rememberHandle(id, params.get(RESUME_HANDLE_PARAM));
      add(id);
      updateAll();
    }

    // Drop the params either way so a refresh does not re-trigger it.
    params.delete(RESUME_PARAM);
    params.delete(RESUME_HANDLE_PARAM);
    var qs = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : '') + window.location.hash);
  }

  function init() {
    resumePending();
    updateAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ---- Public API (used by sections/main-wishlist.liquid) ---- */

  window.UICWishlist = {
    /* [{ id, handle }] in save order; entries saved before handles were
       recorded come back with handle null and cannot be rendered. */
    entries: function () {
      var handles = getHandles();
      return getWishlist().map(function (id) {
        return { id: id, handle: handles[id] || null };
      });
    },
    /* Save without a button to click -- used by the cart's "remove or
       save" choice. Returns what happened so the caller can decide
       whether to go ahead with its own side effects:

         'saved'   added just now
         'already' was already on the list
         'login'   not signed in, the login prompt is now open

       On 'login' the caller must NOT treat this as a save. The id is
       carried through the login round trip by openModal and picked up
       by resumePending on return, so the item is saved then -- but it
       has not been saved yet, and anything the caller does in the
       meantime (removing the line from the cart) would lose it. */
    save: function (id, handle) {
      id = String(id);
      rememberHandle(id, handle);

      if (isWishlisted(id)) return 'already';
      if (!isLoggedIn() && openModal(id, handle)) return 'login';

      add(id);
      updateAll();
      toast('Saved to your wishlist', true);
      return 'saved';
    },
    remove: function (id) {
      var list = getWishlist();
      var idx = list.indexOf(String(id));
      if (idx !== -1) {
        list.splice(idx, 1);
        saveWishlist(list);
        toast('Removed from your wishlist', false);
      }
      updateAll();
    },
    refresh: updateAll
  };

  /* Another tab changed the list. localStorage only fires `storage` in
     OTHER documents, never the one that wrote it, so this cannot loop
     back on itself. Keeps the header badge and an open wishlist page
     honest when the customer has two tabs open -- saving from the cart
     in one and watching the wishlist in the other is exactly the case
     this is for. */
  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY && event.key !== HANDLE_KEY) return;
    updateAll();
    notifyChanged('storage');
  });

  var debounceTimer;
  new MutationObserver(function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateAll, 300);
  }).observe(document.body, { childList: true, subtree: true });
})();
